import { Injectable, inject } from '@angular/core';
import { PatientService } from './patient/patient.service';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private patientService = inject(PatientService);
    private allow_refill = false;
  
    setAllowRefill(allowRefill: boolean): void {
        this.allow_refill = allowRefill;
    }
  
    getAllowRefill(): boolean {
        return this.allow_refill;
    }

    isAuthenticated(): boolean {
        const hasTokens = !!localStorage.getItem('auth_token') && !!localStorage.getItem('token');

        if (!hasTokens) {
          return false;
        }

        return true;
    }

    getRegistrationCode(): string | null {
        return this.patientService.getRegistrationCode() || null;
    }

    logout(): void {
        this.clearCredentials();
        this.allow_refill = false;
    }

    /**
     * Returns the authorization token from localStorage.
     * Used by HttpService to attach Authorization header.
     */
    getAuthorization(): string | null {
        return localStorage.getItem('auth_token');
    }

    /**
     * Call after checkStatus() resolves to persist the web session token and patient data.
     * token will be absent until the backend implements it — updateSessionToken() in HttpService
     * will handle rolling it automatically once the backend starts returning it.
     */
    saveAuthDetails(res: any): void {
        if (res?.token) {
            localStorage.setItem('token', res.token);
        }
        if (res?.auth_token) {
          localStorage.setItem('auth_token', res.auth_token);
        }
    }

    // ─── Session Clearing ─────────────────────────────────────────────────────

    clearCredentials(): void {
        this.patientService.clearSession();
        localStorage.clear();
        sessionStorage.clear();
    }
}
